import type { Device } from "../types";
import { DeviceCard } from "./DeviceCard";

interface DeviceListProps {
  devices: Device[];
  detailsSearch?: string;
}

export function DeviceList({ devices, detailsSearch = "" }: DeviceListProps) {
  return (
    <div className="wgrid">
      {devices.map((device) => (
        <DeviceCard
          key={String(device.id)}
          device={device}
          detailsSearch={detailsSearch}
        />
      ))}
    </div>
  );
}
